export default __webpack_public_path__ + "static/media/getting_started.c2af250b.jpg";